var map = {
	"./CS.jpg": "7e2e",
	"./acturial science.jpg": "43f7",
	"./artsci.jpg": "c744",
	"./background.jpg": "1100",
	"./biology.jpg": "6eda",
	"./bird.jpg": "4f2f",
	"./building.jpeg": "68d3",
	"./cat.jpeg": "5069",
	"./chem.jpg": "365e",
	"./chemistry.jpg": "501f",
	"./civ.jpg": "bcfc",
	"./conv_hall.png": "e730",
	"./conv_hall_ori.jpeg": "cc21",
	"./criminology.jpg": "5bdf",
	"./earth science.jpg": "19f3",
	"./ece.jpeg": "75fe",
	"./eco.jpg": "4ee9",
	"./econ.jpg": "3fdd",
	"./engineering.png": "8969",
	"./english.jpg": "e6c9",
	"./engsci.jpg": "4781",
	"./fileicon/ai.svg": "2159",
	"./fileicon/avi.svg": "fd0b",
	"./fileicon/css.svg": "6bb6",
	"./fileicon/csv.svg": "b8d3",
	"./fileicon/dbf.svg": "8b3e",
	"./fileicon/doc.svg": "3e79",
	"./fileicon/dwg.svg": "909a",
	"./fileicon/exe.svg": "7874",
	"./fileicon/fileicon": "2c14",
	"./fileicon/fileicon.json": "2c14",
	"./fileicon/fla.svg": "5945",
	"./fileicon/html.svg": "b5eb",
	"./fileicon/isi.svg": "bbac",
	"./fileicon/jpg.svg": "b353",
	"./fileicon/js.svg": "a78d",
	"./fileicon/json.svg": "bf03",
	"./fileicon/mp3.svg": "2371",
	"./fileicon/mp4.svg": "74f7",
	"./fileicon/other.svg": "fe3f",
	"./fileicon/pdf.svg": "e180",
	"./fileicon/png.svg": "7175",
	"./fileicon/ppt.svg": "a674",
	"./fileicon/psd.svg": "3478",
	"./fileicon/rtf.svg": "abee",
	"./fileicon/svg.svg": "9d93",
	"./fileicon/txt.svg": "7f96",
	"./fileicon/xls.svg": "7b37",
	"./fileicon/xml.svg": "1a95",
	"./fileicon/zip.svg": "48e2",
	"./google.png": "cebc",
	"./human biology.jpg": "e070",
	"./indy.jpg": "d2cd",
	"./julian.jpeg": "c47f",
	"./linguistics.jpg": "ee05",
	"./logo.svg": "9b19",
	"./mat.jpg": "bb73",
	"./math.jpg": "93b1",
	"./mech.jpg": "ee60",
	"./min.jpg": "65cd",
	"./molecular genetics.jpg": "f8b2",
	"./mse.jpg": "770c",
	"./music.jpg": "ed46",
	"./philosophy.jpg": "7edb",
	"./physics.jpg": "722f",
	"./psy.jpg": "fad3",
	"./psychology.jpg": "9d4d",
	"./rotman.jpg": "7170",
	"./rsm.jpg": "d718",
	"./sta.jpg": "55e8",
	"./star-outline.png": "f7c3",
	"./star.png": "6c8d",
	"./stats.jpg": "0307",
	"./track one.jpeg": "73d0",
	"./uoft.png": "f672"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";